import React from 'react';
import { useIntl } from 'react-intl-next';
import { AdvancedSearchFooter } from '../../advanced-search-footer';
import { messages } from '../messages';
import { QuickFindAdvancedSearchLink } from './quick-find-footer.styled';
import { PersistRecentSearch } from '../../recent-searches/persist-recent-search';
export var SearchFooter = function SearchFooter(_ref) {
  var linkComponent = _ref.linkComponent;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(QuickFindAdvancedSearchLink, null, /*#__PURE__*/React.createElement(AdvancedSearchFooter, {
    linkComponent: linkComponent,
    squareReturnIcon: true,
    searchFooterLabel: formatMessage(messages.quick_find_footer_full_page_search_link)
  }));
};

// wraps the search footer with persistRecentSearch
export var SearchFooterPersistRecentSearch = function SearchFooterPersistRecentSearch(_ref2) {
  var linkComponent = _ref2.linkComponent;
  return /*#__PURE__*/React.createElement(PersistRecentSearch, null, /*#__PURE__*/React.createElement(SearchFooter, {
    linkComponent: linkComponent
  }));
};